/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Every_Too_ShortInputs */

const vi_error_irrigation_schedule_every_too_short = /** @type {(inputs: Error_Irrigation_Schedule_Every_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chu kỳ lặp phải dài hơn thời lượng tưới ít nhất 1 phút`)
};

/**

* @param {Error_Irrigation_Schedule_Every_Too_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_every_too_short = /** @type {((inputs?: Error_Irrigation_Schedule_Every_Too_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Every_Too_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_every_too_short(inputs)
});